<div class="modal fade campanha-enviar-analise-form-modal"
    [class.campanha-enviar-analise-aprovar]="entity?.aprovada"
    [class.campanha-enviar-analise-reprovar]="!entity?.aprovada">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{config?.title}}
                </h4> 
                <h6 class="modal-subtitle">
                    {{config?.subTitle}}
                </h6>                                              
            </div>

            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entity"> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label">Área</label>
                                <input type="text" class="form-control" [value]="campanha?.area?.nome" disabled="disabled" readonly="readonly">
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label">Campanha</label>
                                <input type="text" class="form-control" [value]="campanha?.nome" disabled="disabled" readonly="readonly">                           
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label">Descrição</label>
                                <textarea class="form-control" rows="5" disabled="disabled" readonly="readonly">{{campanha?.descricao}}</textarea>
                            </div>
                        </div>                                                             
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="justificativaAnalise" class="col-form-label">{{config?.justifiticativaLabel}}</label>
                                <textarea class="form-control" [(ngModel)]="entity.justificativaAnalise" name="justificativaAnalise" id="justificativaAnalise" 
                                    #justificativaAnalise="ngModel" #justificativaAnaliseTextArea rows="5" required="required" minlength="15" [autofocus]="true">
                                </textarea>
                                <p class="form-text">{{config?.justifiticativaHelText}}</p>
                                <sgt-form-control-error
                                    *ngIf="justificativaAnalise.errors && justificativaAnalise.errors.required && justificativaAnalise.dirty"
                                    msgError="A justificativa é obrigatória">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="justificativaAnalise.errors && justificativaAnalise.errors.minlength"
                                    msgError="A justificativa deve ter no mínimo 15 caracteres">
                                </sgt-form-control-error>                                                                                               
                            </div>
                        </div>
                    </div>
                </form>                
            </div>

            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-ban"></i> Cancelar
                </button> 
                
                <button type="button" class="btn btn-enviar-analise" [disabled]="!form.valid" (click)="enviarAnalise()" id="btnEnviarAnalise" *ngIf="config">
                    <i class="{{config?.btnEnviarAnaliseIcon}}"></i> {{config?.btnEnviarAnaliseText}}
                </button>                                
            </div>            
        </div>
    </div>
</div>